import React from 'react';
import classnames from 'classnames';
import { ThumbnailList } from '../ThumbnailList';
import { utils } from '@ohif/core';
import { useThumbnailLocationListener } from '@state';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../Accordion';
import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip';
import { useViewerLayoutContext } from '../../contextProviders';
const { formatDate } = utils;

const StudyItem = ({
  servicesManager,
  date,
  description,
  numInstances,
  patientName,
  patientBirthday,
  patientSex,
  accessionNumber,
  isExpanded,
  displaySets,
  modalities,
  isActive,
  onClick,
  onClickThumbnail,
  onDoubleClickThumbnail,
  onClickUntrack,
  activeDisplaySetInstanceUIDs,
  viewPreset = 'thumbnails',
  ThumbnailMenuItems,
  StudyMenuItems,
  StudyInstanceUID,
}: withAppTypes) => {
  const thumbnailLocation = useThumbnailLocationListener();
  const { isPatientMobile } = useViewerLayoutContext();

  return (
    <Accordion
      type="single"
      collapsible
      onClick={onClick}
      onKeyDown={() => {}}
      role="button"
      tabIndex={0}
      defaultValue={isActive ? 'study-item' : undefined}
    >
      <AccordionItem
        value="study-item"
        className={classnames('group relative', thumbnailLocation == 'top' ? 'flex' : '')}
      >
        <AccordionTrigger
          className={classnames('group w-full rounded bg-[#383842] hover:bg-[#383842]')}
        >
          <div className="flex h-[40px] w-full flex-row overflow-hidden">
            <div className="flex w-full flex-row items-center justify-between">
              <div className="flex min-w-0 flex-col items-start text-[11px]">
                <Tooltip>
                  <TooltipContent>
                    {`${accessionNumber} ${formatDate(date, 'YYYY-MM-DD')}`}
                  </TooltipContent>
                  <TooltipTrigger asChild>
                    <div className="h-[13px] w-full max-w-[160px] overflow-hidden truncate whitespace-nowrap text-left text-white">
                      {`${accessionNumber} ${formatDate(date, 'YYYY-MM-DD')}`}
                    </div>
                  </TooltipTrigger>
                </Tooltip>
                <Tooltip>
                  <TooltipContent>
                    {`${patientName} ${patientBirthday} ${patientSex}`}
                  </TooltipContent>
                  <TooltipTrigger asChild>
                    <div className="h-[13px] w-full max-w-[160px] overflow-hidden truncate whitespace-nowrap text-left text-white">
                      {`${patientName} ${patientBirthday} ${patientSex}`}
                    </div>
                  </TooltipTrigger>
                </Tooltip>
                <Tooltip>
                  {description ? <TooltipContent>{description}</TooltipContent> : null}
                  <TooltipTrigger asChild>
                    <div className="h-[13px] w-full overflow-hidden truncate whitespace-nowrap text-left text-white">
                      {description || ''}
                    </div>
                  </TooltipTrigger>
                </Tooltip>
              </div>
              <div className="flex flex-col items-end pl-[10px] text-[12px] text-[#e51c47]">
                <div className="max-w-[150px] overflow-hidden text-ellipsis">{modalities}</div>
                <div>{numInstances}</div>
              </div>
            </div>
          </div>
        </AccordionTrigger>
        {StudyMenuItems && !isPatientMobile && (
          <div
            className="absolute right-2 top-2 z-10 flex items-center"
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
            }}
          >
            <StudyMenuItems StudyInstanceUID={StudyInstanceUID} />
          </div>
        )}
        <AccordionContent
          onClick={event => {
            event.stopPropagation();
          }}
        >
          {isExpanded && displaySets && (
            <ThumbnailList
              servicesManager={servicesManager}
              thumbnails={displaySets}
              activeDisplaySetInstanceUIDs={activeDisplaySetInstanceUIDs}
              onThumbnailClick={onClickThumbnail}
              onThumbnailDoubleClick={onDoubleClickThumbnail}
              onClickUntrack={onClickUntrack}
              viewPreset={viewPreset}
              ThumbnailMenuItems={ThumbnailMenuItems}
              patientName={patientName}
              patientBirthday={patientBirthday}
              patientSex={patientSex}
              accessionNumber={accessionNumber}
              description={description}
            />
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export { StudyItem };
